import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SharedModule } from '../shared/modules/shared.module';

import { routing } from './job.routing';
import { AppComponent } from '../app.component';
import { ListComponent } from './list/list.component';
import { JobAddressDialog, JobStatusDialog, SummaryComponent } from './summary/summary.component';

import { AuthGuard } from '../auth.guard';
import { JobService } from './services/job.service';
import { DateService } from '../shared/services/date.service';
import { RouterModule } from '@angular/router';
import { ListDesktopComponent } from './list/list-desktop/list-desktop.component';
import { ListMobileComponent } from './list/list-mobile/list-mobile.component';
import { ChangeOrderDialog } from './change-order-dialog/change.order.dialog';
import { SummaryMobileComponent } from './summary/summary-mobile/summary-mobile.component';
import { SummaryDesktopComponent } from './summary/summary-desktop/summary-desktop.component';
import { ChangeOrderDesktopComponent } from './change-order/change-order-desktop/change.order.desktop.component';
import { ChangeOrderMobileComponent } from './change-order/change-order-mobile/change.order.mobile.component';
import { ChangeOrderAreaDialog } from './change-order-area-dialog/change.order.area.dialog';
import { ChangeOrderApproveDialog } from './change-order-approve-dialog/change.order.approve.dialog';
import { JobCostItemDialog } from './job-cost-item-dialog/job-cost-item.dialog';
import { ChangeOrderPrintDialog } from './change-order-print-dialog/change.order.print.dialog';
import { JobCustomWorkAreaDialog } from './job-custom-work-area-dialog/job-custom-work-area-dialog';
import { ArrivalNotificationDialog } from './arrival-notification-dialog/arrival-notification-dialog';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forRoot(routing, {}),
    SharedModule
  ],
  declarations: [ListComponent, ListDesktopComponent, ListMobileComponent,
    SummaryComponent, SummaryMobileComponent, SummaryDesktopComponent,
    JobStatusDialog, JobAddressDialog,
    ChangeOrderDesktopComponent, ChangeOrderMobileComponent,
    ChangeOrderDialog,
    ChangeOrderAreaDialog,
    ChangeOrderApproveDialog,
    JobCostItemDialog,
    JobCustomWorkAreaDialog,
    ChangeOrderPrintDialog,
    ArrivalNotificationDialog],
  exports: [ChangeOrderDialog],
  providers: [AppComponent, AuthGuard, JobService, DateService]
})
export class JobModule { }
